import { render } from "./HeaderChallengeRequests.vue?vue&type=template&id=2fb05601&scoped=true"
import script from "./HeaderChallengeRequests.vue?vue&type=script&lang=js"
export * from "./HeaderChallengeRequests.vue?vue&type=script&lang=js"

import "@/css/components/header-challenge-requests.css?vue&type=style&index=0&id=2fb05601&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb05601"]])

export default __exports__